import type { ButtonHTMLAttributes } from 'react';
import type { LucideIcon } from 'lucide-react';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: LucideIcon;
  size?: number;
  variant?: 'plain' | 'filled';
}

export function IconButton({ icon: Icon, size = 18, variant = 'plain', className = '', ...rest }: IconButtonProps) {
  return (
    <button
      className={
        (variant === 'filled'
          ? 'bg-blue-600 text-white hover:bg-blue-700 '
          : 'text-current hover:bg-black/5 dark:hover:bg-white/10 ') +
        'inline-flex items-center justify-center rounded-full w-9 h-9 transition-colors active:scale-95 ' +
        className
      }
      {...rest}
    >
      <Icon size={size} strokeWidth={2.2} />
    </button>
  );
}
